import { Injectable } from '@angular/core';
import { EnviromentContextService } from '../../enviroment/services/enviroment-context-service';

export class ApiConfigService {

  constructor(private enviromentContextService: EnviromentContextService, private server: string, private protocol: string) { }

  public getUrlBase(): string {
    return `${this.protocol}://${this.server}/v2.0/ef42d319-47c9-4f6b-b37f-e795d2bd1c5e/${this.enviromentContextService.getEnviroment()}`;
  }

  public getUrl(fragment: string) : string {
    return `${this.getUrlBase()}/${fragment}`;
  }
}
